import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportCsvRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-csv',
	path: '/(secure|secure/admin)/Csv(\\w+)Page([!%]?[\\w]*).jspa',
};
